/* eslint-disable
    guard-for-in,
    prefer-rest-params,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import {assertAndContinue} from 'Asserts';
import sortedBy from 'util/sortedBy';

const prefixes = {
  Y: 24,
  Z: 21,
  E: 18,
  P: 15,
  T: 12,
  G: 9,
  M: 6,
  k: 3,
  h: 2,
  da: 1,
  '': 0,
  d: -1,
  c: -2,
  m: -3,
  u: -6,
  µ: -6,
  n: -9,
  p: -12,
  f: -15,
  a: -18,
  z: -21,
  y: -24,
} as const;

type Prefix = keyof typeof prefixes;

interface RawDict {
  raw: string;
  meta?: Amount;
}

const CHAR = {
  MU: '\u00B5',
  DEG: '\u00B0',
  TIMES: '\u00D7',
};
const NUMBER_RE = '[\\d,]+\\.?\\d*';
const PARSE_CLASS = 'auto-parsed';

function tenFactor(prefix: Prefix): number {
  return prefixes[prefix];
}

function formatPrefix(prefix: Prefix): Prefix | string {
  if (prefix === 'u') {
    return CHAR.MU;
  } else {
    return prefix;
  }
}

function rawDict(str: string): RawDict {
  return {
    raw: str,
  };
}

class ParsedValue {
  regex!: string | null;
  base!: string | null;
  boundaryLeft!: string;
  boundaryRight!: string;

  static initClass(): void {
    this.prototype.boundaryLeft = '\\b'; // Note boundaryLeft/Right shouldn't capture anything.

    this.prototype.boundaryRight = '\\b';
  }
  parseAmount(str: string): Amount {
    throw new Error('not implemented');
  }

  amountRegex(): string {
    throw new Error('not implemented');
  }
}
ParsedValue.initClass();

class Unit extends ParsedValue {
  static initClass(): void {
    this.prototype.regex = null;
    this.prototype.base = null;
  }

  parseAmount(str: string): Amount {
    const r = new RegExp(`^${this.amountRegex()}$`);
    const match = r.exec(str);
    assertAndContinue(match != null, `Expected ${str} to match against ${r}`);

    const amount = parseFloat(match![1].split(',').join(''));
    const prefix = match![2] as Prefix;
    const adjustedFactor = tenFactor(prefix);
    const adjustedAmount = amount * Math.pow(10, adjustedFactor);

    const htmlAmount = match![1];
    const htmlUnit = `${formatPrefix(prefix)}${this.base}`;
    return new Amount({unit: this, amount: adjustedAmount, htmlAmount, htmlUnit});
  }

  amountRegex(): string {
    return `(${NUMBER_RE})\\s*${this.regex}`;
  }
}
Unit.initClass();

class BaseUnit extends Unit {
  static initClass(): void {
    this.prototype.regex = null;
    this.prototype.base = null;
  }
  constructor({base, match}: {base: string; match?: Array<string>}) {
    // @ts-expect-error A spread argument must either have a tuple type or be passed to a rest parameter ts(2556)
    super(...arguments);
    this.base = base;
    const baseRe = match != null ? `(?:${match.join('|')})` : this.base;
    const prefixRe = (() => {
      const result = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const prefix in prefixes) {
        result.push(prefix);
      }
      return result;
    })().join('|');
    this.regex = `(${prefixRe})${baseRe}`;
  }
}
BaseUnit.initClass();

class DNAUnit extends BaseUnit {
  parseAmount(str: string): Amount {
    const r = new RegExp(`^${this.amountRegex()}$`);
    const match = r.exec(str);
    assertAndContinue(match != null, `Expected ${str} to match against ${r}`);

    const amount = parseFloat(match![1].split(',').join(''));
    const prefix = match![2] as Prefix;
    const adjustedFactor = tenFactor(prefix);
    const adjustedAmount = Math.floor(amount * Math.pow(10, adjustedFactor));

    const htmlAmount = match![1];
    const htmlUnit = prefix.length ? `${formatPrefix(prefix)}b` : 'bp';
    return new Amount({unit: this, amount: adjustedAmount, htmlAmount, htmlUnit});
  }

  amountRegex(): string {
    return `([\\d,.]+)\\s*${this.regex}`;
  }
}

class RatioUnit extends Unit {
  numerator!: Unit | null;
  denominator!: Unit | null;

  static initClass(): void {
    this.prototype.numerator = null;
    this.prototype.denominator = null;
    this.prototype.regex = null;
  }

  constructor({numerator, denominator}: {numerator: Unit; denominator: Unit}) {
    // @ts-expect-error A spread argument must either have a tuple type or be passed to a rest parameter ts(2556)
    super(...arguments);
    Object.assign(this, {numerator, denominator});
    // Takes two BaseUnits
    this.regex = `${this.numerator!.regex}\\s*/\\s*${this.denominator!.regex}`;
    this.base = `${this.numerator!.base}/${this.denominator!.base}`;
  }

  parseAmount(str: string): Amount {
    const r = new RegExp(`^${this.amountRegex()}$`);
    const match = r.exec(str);
    assertAndContinue(match != null, `Expected ${str} to match against ${r}`);

    const amount = parseFloat(match![1]);
    const prefix1 = match![2] as Prefix;
    const prefix2 = match![3] as Prefix;

    const factor1 = tenFactor(prefix1);
    const factor2 = tenFactor(prefix2);

    const adjustedFactor = factor1 - factor2;
    const adjustedAmount = amount * Math.pow(10, adjustedFactor);

    const htmlAmount = match![1];
    const htmlUnit = `${formatPrefix(prefix1)}${this.numerator!.base}/${formatPrefix(prefix2)}${
      this.denominator!.base
    }`;
    return new Amount({unit: this, amount: adjustedAmount, htmlAmount, htmlUnit});
  }
}
RatioUnit.initClass();

class SignedValue extends ParsedValue {
  static initClass(): void {
    // Signed values can start with a - which is not a word character, so \b won't suffice.
    this.prototype.boundaryLeft =
      '\\b(?!-)' /* Match word boundaries that aren't negative sign.
       For 1-4degC we match 4degC instead of -4degC. */ +
      '|' +
      '(?:^|\\s)(?=-)'; /* Match negative sign only if at line start or after whitespace.
     Don't consume negative as amountRegex will. */
  }
}
SignedValue.initClass();

class Degrees extends SignedValue {
  parseAmount(str: string): Amount {
    const r = new RegExp(`^${this.amountRegex()}$`);
    const match = r.exec(str);
    assertAndContinue(match != null, `Expected ${str} to match against ${r}`);

    const amount = parseFloat(match![1]);
    const htmlAmount = match![1];
    const scale = CHAR.DEG + match![2];
    return new Amount({unit: this, amount, htmlAmount, htmlUnit: scale});
  }

  amountRegex(): string {
    return `(-?${NUMBER_RE})\\s*(?:deg|${CHAR.DEG})\\s*(C|F)`;
  }
}

class ExpNotationNumber extends SignedValue {
  parseAmount(str: string): Amount {
    const r = new RegExp(`^${this.amountRegex()}$`);
    const match = r.exec(str);
    assertAndContinue(match != null, `Expected ${str} to match against ${r}`);

    const mantissa = parseFloat(match![1]);
    const exponent = parseFloat(match![2]);
    const actualAmount = mantissa * Math.pow(10, exponent);
    const htmlAmount = `${mantissa}&nbsp;${CHAR.TIMES}&nbsp;10<sup>${exponent}</sup>`;
    return new Amount({unit: this, amount: actualAmount, htmlAmount, htmlUnit: null});
  }

  amountRegex(): string {
    return `(-?${NUMBER_RE})\\s*(?:x|${CHAR.TIMES})\\s*10\\^(-?${NUMBER_RE})`;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ChemicalFormula: any = (function () {
  let ELEMENT_REGEX: string;
  let COUNT: string;
  ChemicalFormula = class ChemicalFormula extends ParsedValue {
    regexCache: string | null | undefined;

    static initClass(): void {
      // Sort and reverse to get longer elements first.
      ELEMENT_REGEX = sortedBy(
        [
          'H',
          'He',
          'Li',
          'Be',
          'B',
          'C',
          'N',
          'O',
          'F',
          'Ne',
          'Na',
          'Mg',
          'Al',
          'Si',
          'P',
          'S',
          'Cl',
          'K',
          'Ar',
          'Ca',
          'Sc',
          'Ti',
          'V',
          'Cr',
          'Mn',
          'Fe',
          'Ni',
          'Co',
          'Cu',
          'Zn',
          'Ga',
          'Ge',
          'As',
          'Se',
          'Br',
          'Kr',
          'Rb',
          'Sr',
          'Y',
          'Zr',
          'Nb',
          'Mo',
          'Tc',
          'Ru',
          'Rh',
          'Pd',
          'Ag',
          'Cd',
          'In',
          'Sn',
          'Sb',
          'I',
          'Te',
          'Xe',
          'Cs',
          'Ba',
          'La',
          'Ce',
          'Pr',
          'Nd',
          'Pm',
          'Sm',
          'Eu',
          'Gd',
          'Tb',
          'Dy',
          'Ho',
          'Er',
          'Tm',
          'Yb',
          'Lu',
          'Hf',
          'Ta',
          'W',
          'Re',
          'Os',
          'Ir',
          'Pt',
          'Au',
          'Hg',
          'Tl',
          'Pb',
          'Bi',
          'At',
          'Po',
          'Rn',
          'Fr',
          'Ra',
          'Ac',
          'Pa',
          'Th',
          'Np',
          'U',
          'Am',
          'Pu',
          'Bk',
          'Cm',
          'Cf',
          'Es',
          'Fm',
          'Md',
          'No',
          'Rf',
          'Db',
          'Lr',
          'Bh',
          'Sg',
          'Mt',
          'Ds',
          'Rg',
          'Hs',
          'Uut',
          'Cn',
          'Uup',
          'Fl',
          'Lv',
          'Uuo',
          'Uus',
        ],
        [(el) => el]
      )
        .reverse()
        .join('|');
      COUNT = '\\d+';
    }

    parseAmount(str: string): Amount {
      let match;
      const r = new RegExp(`(dH|ddH|${ELEMENT_REGEX})(${COUNT})?`, 'g');
      let htmlUnit = '';
      // eslint-disable-next-line no-cond-assign
      while ((match = r.exec(str))) {
        htmlUnit += match[1];
        if (match[2] != null && match[2].length) {
          htmlUnit += `<sub>${match[2]}</sub>`;
        }
      }
      return new Amount({unit: this, amount: 1, htmlAmount: '', htmlUnit});
    }

    amountRegex(): string {
      if (this.regexCache == null) {
        this.regexCache = new RegExp(`\
ddH2O|dH2O\
|\
(\
(\
(${ELEMENT_REGEX})(${ELEMENT_REGEX})(${COUNT})?\
|\
(${ELEMENT_REGEX})${COUNT}\
)\
((${ELEMENT_REGEX})(${COUNT})?)*\
)\
`).source;
      }
      return this.regexCache;
    }
  };
  ChemicalFormula.initClass();
  return ChemicalFormula;
})();

export class Amount {
  unit: Unit;
  amount: number;
  htmlAmount: string;
  htmlUnit: string | null;

  constructor({
    unit,
    amount,
    htmlAmount,
    htmlUnit,
  }: {
    unit: Unit;
    amount: number;
    htmlAmount: string;
    htmlUnit: string | null;
  }) {
    this.unit = unit;
    this.amount = amount;
    this.htmlAmount = htmlAmount;
    this.htmlUnit = htmlUnit;
  }
  toString(): string {
    return `${this.htmlAmount}${this.htmlUnit ? this.htmlUnit : ''}`;
  }
}

const MASS = new BaseUnit({base: 'g'});
const VOLTAGE = new BaseUnit({base: 'V'});
const VOL = new BaseUnit({base: 'L', match: ['l', 'L']});
const MOL = new BaseUnit({base: 'mol'});
const ACTIVITY = new BaseUnit({base: 'U'});
const DNA = new DNAUnit({base: 'bp', match: ['b', 'bp']});
const MOLAR = new RatioUnit({numerator: MOL, denominator: VOL});
const MOLAR2 = new BaseUnit({base: 'M'});
const ACTIVITY_PER_VOL = new RatioUnit({numerator: ACTIVITY, denominator: VOL});
const DENSITY = new RatioUnit({numerator: MASS, denominator: VOL});
const DEGREE = new Degrees();
const EXP_NOTATION = new ExpNotationNumber();
const CHEMICAL_FORMULA = new ChemicalFormula();

function parseRegex(data: Array<RawDict>, parser: Unit): Array<RawDict> {
  const regex = new RegExp(`(${parser.boundaryLeft})(${parser.amountRegex()})${parser.boundaryRight}`);
  let i = 0;
  while (i < data.length) {
    const datum = data[i];
    if (datum.meta != null) {
      // Has already been parsed.
      i++;
      continue;
    }
    const match = regex.exec(datum.raw);
    let delta = 1;
    if (match != null) {
      const start = match.index + match[1].length;
      const end = start + match[2].length;
      const [first, raw, last] = Array.from([
        datum.raw.slice(0, start),
        datum.raw.slice(start, end),
        datum.raw.slice(end),
      ]);
      const replacement: Array<RawDict> = [{raw, meta: parser.parseAmount(raw)}];
      if (first.length) {
        replacement.unshift(rawDict(first));
        // We want to skip over first, but not last.
        delta++;
      }
      if (last.length) {
        replacement.push(rawDict(last));
      }
      data = [...data.slice(0, i), ...replacement, ...data.slice(i + 1)];
    }
    i += delta;
  }
  return data;
}

function parse(str: string): Array<RawDict> {
  let data = [rawDict(str)];
  const parsers = [
    DNA,
    MOLAR,
    MOLAR2,
    DENSITY,
    ACTIVITY_PER_VOL,
    MOL,
    VOL,
    MASS,
    VOLTAGE,
    ACTIVITY,
    DEGREE,
    EXP_NOTATION,
    CHEMICAL_FORMULA,
  ];
  for (const parser of Array.from(parsers)) {
    data = parseRegex(data, parser);
  }
  return data;
}

function parseHTML(str: string): string {
  const parts = parse(str).map((part) => {
    if (part.meta == null) {
      return part.raw;
    }
    return `<span class='${PARSE_CLASS}'>${part.meta.toString()}</span>`;
  });
  return parts.join('');
}

export {
  parse as __parse,
  parseHTML,
  ACTIVITY,
  ACTIVITY_PER_VOL,
  DENSITY,
  DNA,
  MASS,
  MOLAR,
  MOLAR2,
  MOL,
  VOL, // DEGREE: DEGREE
  // EXP_NOTATION: EXP_NOTATION
  VOLTAGE,
  RawDict,
};
